import React, {useState, useEffect, useContext} from 'react';
import { fetchWithDefaults } from '../../../config/fetchDefault';
import { getCurrentAge, calculateAge, dobFormat, validDOB, validateAge } from '../../../utilities/timeFunctions';
import Icon from '../../../assets/icons/icon.js'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchLeadDataThunk } from '../../../features/leadDataInfoSlice.js';
import { inputMask } from '../../../utilities/genericUtils.js';
import { AgentContext } from '../../../context/AgentContext.js';

function QualifierSection({ data, setLead, agentId, handleSetProfile}) {
    const isFeature580Enabled = process.env.REACT_APP_FUNNEL_FEATURE_580 === 'true'
    const [borrowerDate, setBorrowerDate] = useState('');
    const [borrowerError, setBorrowerError] = useState('');
    const [coBorrowerError, setCoBorrowerError] = useState('');
    const [coBorrowerDate, setCoBorrowerDate] = useState(false);
    const [showDOBTooltip, setShowDOBToolTip] = useState(false);

    // ===== leads popup full data =====
    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);

    const [sectionLeadData, setSectionLeadData] = useState({...leadsAlldata})

    const dispatch = useDispatch()

    const handleChange = (event, column) => {
        const { value } = event.target;

        if(column === 'borrower_age' || column === 'co_borrower_age'){
            const newAge =  typeof value === 'number' ? value : value.replace(/\D/g, '')

            if(validateAge(newAge)){
                // setLead(column, newAge)
                setSectionLeadData((prevData) => ({...prevData, ...{[column]: newAge}}))
            }
        } else {
            // setLead(column, value);
            setSectionLeadData((prevData) => ({...prevData, ...{[column]: value}}))
        }
    };
    const parseWeight = (input) => {
        // Use a regular expression to extract the numeric part
        const parsedWeight = parseInt(input.match(/\d+/), 10);
        return parsedWeight;
    };
    const handleBlur = async (value, column, leadId) => {
        let newValue=value;

        if(column === 'borrower_age' || column === 'co_borrower_age'){
            const newAge = typeof newValue === 'number' ? newValue : newValue.replace(/\D/g, '')

            if(validateAge(newAge)){
                newValue = newAge
            } else {
                // don't update the lead when the age is invalid
                return
            }
        } else {
            if(column==='weight'){
                newValue=parseWeight(value);
            }
        }

        console.log('handleBlur-section', {[column]: leadsAlldata[column]}, {value, column})
        if(leadsAlldata[column] == value){
            return
        }

        handleSetProfile(column, newValue)

        try {
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify({
                    agent:agentId,
                    lead:leadId,
                    column:column,
                    value: newValue
                })
            };

            const response = await fetchWithDefaults('/updateLead', requestOptions);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();

            if(jsonData.status === true){
                await dispatch(fetchLeadDataThunk({leadId}))
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const dobChange = (val, column) => {
        const value = val.replace(/\D/g, ''); // Remove non-digit characters
        const formattedDate = formatDate(value);
        if(column==='borrower_dob'){
            setBorrowerDate(formattedDate);
            // setLead('borrower_dob', formattedDate)
        }
        else{
            setCoBorrowerDate(formattedDate);
        }
    };

    const formatDate = (value) => {
        let mask = '##'

        if (value.length >= 5) {
            mask = '##/##/####'
        } else if (value.length >= 3) {
            mask = '##/##'
        }

        const date = inputMask(value, mask, '#', (r, _m, _p) => r.replace(/\D/g, ''))
        return date
    };
    const handleDateBlur=(event, column, leadId)=>{
        const valididy=validDOB(event.target.value);
        if(valididy.isValid){
            if(column==='borrower_dob'){
                setBorrowerError('');
            }
            else{
                setCoBorrowerError('');
            }
            const age = isFeature580Enabled===true ? getCurrentAge(event.target.value) : calculateAge(event.target.value);
            const validAge = validateAge(age)
            const newColumn=column==='borrower_dob' ? 'borrower_age' : 'co_borrower_age';

            handleBlur(event.target.value, column, leadId);
            if(valididy.date !== '' && validAge){
                setLead(newColumn, age);
                handleBlur(age, newColumn, leadId);
            }
        }
        else{
            if(column==='borrower_dob'){
                setBorrowerError(valididy.error);
            }
            else{
                setCoBorrowerError(valididy.error);
            }
        }
    }

    useEffect(() => {
        setCoBorrowerDate(dobFormat(sectionLeadData?.co_borrower_dob ? sectionLeadData?.co_borrower_dob : ''));
        setBorrowerDate(dobFormat(sectionLeadData?.borrower_dob ? sectionLeadData?.borrower_dob : ''));
    }, [])

    useEffect(() => {
        setSectionLeadData(leadsAlldata)
    }, [leadsAlldata])

    const {isB2B} = useContext(AgentContext)

    return (
        <div className="qualifierSection">
            {data && data.map((item, index) => {
                /** @type {number | undefined} */
                let maxLength = undefined;
                switch (item.column) {
                    case "borrower_first":
                    case "borrower_last":
                    case "co_borrower_first":
                    case "co_borrower_last":
                    case "city":
                    case "lender": {
                        maxLength = 50;
                        break;
                    }
                    case "borrower_age":
                    case "co_borrower_age":
                    case "tobacco":
                    case "co_borrower_tobacco": {
                        maxLength = 3;
                        break;
                    }
                    case "height":
                    case "weight":
                    case "co_borrower_height":
                    case "co_borrower_weight":
                    case "loan_type": {
                        maxLength = 15;
                        break;
                    }
                    case "email":
                    case "co_borrower_email":
                    case "address":
                    case "address2": {
                        maxLength = 75;
                        break;
                    }
                    case "medical_conditions": {
                        maxLength = 300;
                        break;
                    }
                    case "sex":
                    case "borrower_sex":
                    case "co_borrower_sex":
                    case "payment": {
                        maxLength = 7;
                        break;
                    }
                    case "state": {
                        maxLength = 25;
                        break;
                    }
                    case "zip":
                    case "mortgage":
                    case "home_value": {
                        maxLength = 10;
                        break;
                    }
                }
                return (
                    <div className="qualifierFieldWrapper" key={`qualifierField${index}`}>
                        <div className="qualifierFieldTitle">
                            {item.name} {
                                isFeature580Enabled===true && item.column==='borrower_dob' ?
                                    <>
                                        <div
                                            style={{display:'inline-block'}}
                                            onMouseEnter={() => setShowDOBToolTip(true)}
                                            onMouseLeave={() => setShowDOBToolTip(false)}
                                        >
                                            <Icon
                                                name={'info-circle-q'}
                                                height={12}
                                                size={12}
                                                viewBox='-10 0 1024 700'
                                                color={isB2B ? "#1570EF" : "#45bcaa"}
                                            ></Icon>
                                        </div>

                                        <span className="error">{borrowerError}</span>
                                    </>
                                : item.column==='co_borrower_dob' ?
                                        <span className="error">{borrowerError}</span>
                                : ''
                            }
                        </div>
                        {item.column==='borrower_dob' && showDOBTooltip && (
                            <div className="qualifierFieldTitle" style={{width: 'max-content'}}>
                                Enter DOB for most accurate recommendations and pricing
                            </div>
                        )}
                        {item.type==='drop' ? (
                            <select className="outlineButton filterButton" onChange={(event)=>[handleChange(event, item.column),handleBlur(event.target.value, item.column, sectionLeadData?.lead_id)]} value={sectionLeadData[item.column]}>
                                {item.options && item.options.map((option, index) => (
                                    <option value={option.value} key={index}>{option.title}</option>
                                ))}

                            </select>
                        ) : item.column === 'borrower_dob' ? (
                            <input
                                type="text"
                                className="qualifierFieldInput"
                                maxLength={maxLength}
                                placeholder='mm/dd/yyyy'
                                value={borrowerDate}
                                onChange={(event) => dobChange(event.target.value, item.column)}
                                onBlur={(event) => handleDateBlur(event, item.column, sectionLeadData?.lead_id)}
                            />
                        ) : item.column === 'co_borrower_dob' ? (
                            <input
                                type="text"
                                className="qualifierFieldInput"
                                maxLength={maxLength}
                                placeholder='mm/dd/yyyy'
                                value={coBorrowerDate}
                                onChange={(event) => dobChange(event.target.value, item.column)}
                                onBlur={(event) => handleDateBlur(event, item.column, sectionLeadData?.lead_id)}
                            />
                        ) : item.column === 'borrower_age' ? (
                            <input
                                type="text"
                                className="qualifierFieldInput"
                                maxLength={maxLength}
                                value={sectionLeadData[item.column]}
                                onChange={(event) => handleChange(event, item.column)}
                                onBlur={(event) => handleBlur(event.target.value, item.column, sectionLeadData?.lead_id)}
                                disabled={borrowerDate !== ''}
                            />
                        ) : item.column === 'co_borrower_age' ? (
                            <input
                                type="text"
                                className="qualifierFieldInput"
                                maxLength={maxLength}
                                value={sectionLeadData[item.column]}
                                onChange={(event) => handleChange(event, item.column)}
                                onBlur={(event) => handleBlur(event.target.value, item.column, sectionLeadData?.lead_id)}
                                disabled={coBorrowerDate !== ''}
                            />
                        ) : (
                            <input
                                type="text"
                                className="qualifierFieldInput"
                                value={sectionLeadData[item.column]}
                                maxLength={maxLength}
                                onChange={(event) => handleChange(event, item.column)}
                                onBlur={(event) => handleBlur(event.target.value, item.column, sectionLeadData?.lead_id)}
                            />
                        )}
                    </div>
                )
            })}
        </div>
    );
}

export default QualifierSection;
